export function deleteAlert(message) {
  const alertBox = document.createElement("div");

  // Set the HTML content
  alertBox.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px;">
        <svg class="delete-alert-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
          <rect width="40" height="40" rx="4" fill="#FFEAEB"/>
          <path d="M11 14H29" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18 19V25" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M22 19V25" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M27 14V28C27 28.5304 26.7893 29.0391 26.4142 29.4142C26.0391 29.7893 25.5304 30 25 30H15C14.4696 30 13.9609 29.7893 13.5858 29.4142C13.2107 29.0391 13 28.5304 13 28V14" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16 14V12C16 11.4696 16.2107 10.9609 16.5858 10.5858C16.9609 10.2107 17.4696 10 18 10H22C22.5304 10 23.0391 10.2107 23.4142 10.5858C23.7893 10.9609 24 11.4696 24 12V14" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="alert-message ftw-4 common-text">${message}</span>
      </div>
    `;

  // Style the alert container
  alertBox.style.position = "fixed";
  alertBox.style.left = "50%";
  alertBox.style.top = "100px";
  alertBox.style.transform = "translateX(-50%)";
  alertBox.style.backgroundColor = "#FFF";
  alertBox.style.border = "1px solid rgba(255, 0, 0, 0.20)";
  alertBox.style.boxShadow = "0px 8px 15px 0px rgba(255, 0, 0, 0.20)";
  alertBox.style.borderRadius = "13px";
  alertBox.style.padding = "12px 16px";
  alertBox.style.boxSizing = "border-box";
  alertBox.style.zIndex = "1000";
  alertBox.style.animation = "slideDown 0.3s ease-out forwards";

  // Add animation keyframes and responsive styles
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
      .alert-message {
        font-size: 0.875rem;
      }
      .delete-alert-icon {
        width: 40px;
        height: 40px;
      }
      
      @media (max-width: 1599px) {
        .delete-alert-icon { width: 36px; height: 36px; }
      }
      
      @media (max-width: 1399px) {
        .delete-alert-icon { width: 32px; height: 32px; }
      }
      
      @media (max-width: 1199px) {
        .delete-alert-icon { width: 28px; height: 28px; }
      }
      
      @media (max-width: 991px) {
        .delete-alert-icon { width: 24px; height: 24px; }
      }
      
      @media (max-width: 767px) {
        .delete-alert-icon { width: 20px; height: 20px; }
      }
      
      @media (max-width: 575px) {
        .delete-alert-icon { width: 18px; height: 18px; }
      }
      
      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
        to {
          opacity: 1;
          transform: translate(-50%, 0);
        }
      }
      @keyframes fadeOut {
        from {
          opacity: 1;
          transform: translate(-50%, 0);
        }
        to {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
      }
    `;
  document.head.appendChild(styleSheet);

  // Add the alert to the page
  document.body.appendChild(alertBox);

  // Add the alert-box class to the alertBox element
  alertBox.classList.add("alert-box");

  // Remove the alert after 3 seconds
  setTimeout(() => {
    alertBox.style.animation = "fadeOut 0.3s ease-out forwards";
    setTimeout(() => {
      if (document.body.contains(alertBox)) {
        document.body.removeChild(alertBox);
      }
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    }, 300);
  }, 3000);
}
